
import { Component, Prop, Emit, Watch, Mixins } from 'vue-property-decorator';
import SiteLogoWhite from '@/components/SiteLogoWhite.vue';
import LatestMenu from '@/mixins/LatestMenu';
import store from '@/store';
import { getBeginnerNaviUrl, showBeginnerNaviButton } from '@/lib/functions';

@Component({
  components: {
    SiteLogoWhite,
  },
})
export default class FloatBottom extends Mixins(LatestMenu) {
  private name = 'floatBottom';
  private spMenuFlg: boolean = false;
  
  @Emit()
  private openSpMenu(): void {
    this.spMenuFlg = true;
  }

  @Emit()
  private closeSpMenu(): void {
    this.spMenuFlg = false;
  }

  @Emit()
  private openModalSearchNavi(): void {
    store.commit('searchmodal/open', 'ModalSearchnavi');
  }

  private get beginnerNaviUrl(): string {
    return getBeginnerNaviUrl(store.getters["auth/group"]);
  }
  private get showBeginnerNaviButton(): boolean {
    return showBeginnerNaviButton(store.getters["auth/group"]);
  }
  @Watch('$route', { immediate: true, deep: true })
  private onUrlChange(newVal: any) {
    this.closeSpMenu();
  }
}
